<template>
  <div v-if="data.openDialog">
    <div class="dialog__background"></div>
    <div class="alert__dialog">
      <div class="dialog__close" @click="handleClose"></div>
      <div class="dialog__title">{{ data.title }}</div>
      <div class="dialog__content__container" v-if="data.content">
        <div class="dialog__content">{{ data.content }}</div>
      </div>
      <div class="dialog__button">
        <div class="dialog__cancle" @click="handleClose">取消</div>
        <div class="dialog__handle" @click="handleGoDetail($event)">{{ data.text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'alert-dialog',
  props: ['data'],
  data() {
    return {}
  },
  methods: {
    handleGoDetail(event) {
      window.location.replace(this.data.url)
    },
    handleClose() {
      this.$emit('handleCleanData')
    }
  }
}
</script>

<style scoped lang="scss">
.dialog__background {
  display: block;
  width: 100%;
  height: 100%;
  opacity: 0.7;
  position: fixed;
  background: #000000;
  top: 0;
  left: 0;
  z-index: 2000;
}
.alert__dialog {
  width: 446px;
  // height: 234px;
  background: #ffffff;
  border-radius: 2px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  line-height: 25px;
  position: fixed;
  z-index: 2001;
  .dialog__close {
    width: 14px;
    height: 14px;
    position: absolute;
    top: 20px;
    right: 20px;
    background-image: url('../assets/img/close-btn-gray.png');
    background-size: cover;
    background-repeat: no-repeat;
    cursor: pointer;
  }
  .dialog__title {
    font-weight: 600;
    margin-top: 66px;
    text-align: center;
    color: #333333;
    font-size: 16px;
  }
  .dialog__content__container {
    text-align: center;
    .dialog__content {
      text-align: left;
      display: inline-block;
      margin-top: 20px;
      color: #333333;
      font-size: 14px;
      padding: 0 30px 0 30px;
    }
  }
  .dialog__button {
    margin-left: 81px;
    font-size: 14px;
    margin-top: 58px;
    margin-bottom: 32px;
    & > div {
      width: 130px;
      height: 40px;
      text-align: center;
      line-height: 40px;
    }
    .dialog__cancle {
      display: inline-block;
      border: 1px #dedede solid;
      border-radius: 2px;
      cursor: pointer;
    }
    .dialog__handle {
      margin-left: 24px;
      display: inline-block;
      color: #ffffff;
      background: #f13232;
      border-radius: 2px;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/components/AlertDialog.vue